<template>
  <b-badge
    :variant="statusInfo.variant"
    :style="badgeStyle"
    class="lab-status-badge"
  >
    {{ statusInfo.label }}
  </b-badge>
</template>

<script>
import { getLabStatusByValue } from "@/constants/labStatus";

export default {
  name: "LabStatusBadge",
  props: {
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    statusInfo() {
      return getLabStatusByValue(this.status);
    },
    badgeStyle() {
      // For purple variant which is not standard bootstrap
      if (this.statusInfo.variant === 'purple') {
        return {
          backgroundColor: this.statusInfo.color,
          color: '#fff'
        };
      }
      return {};
    }
  }
};
</script>

<style scoped>
.lab-status-badge {
  font-size: 0.85em;
  padding: 0.35em 0.65em;
}
</style>
